import React from 'react';
import { truncate } from 'lodash';
import { Box, TableCell, TableRow, Typography } from '@mui/material';
import useCurrencyFormat from 'hooks/useCurrencyFormat';
import { CostType } from 'components/BudgetCostsList/Result/interfaces';
import DesignServicesOutlinedIcon from '@mui/icons-material/DesignServicesOutlined';
import PaymentOutlinedIcon from '@mui/icons-material/PaymentOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import TitleTooltip from 'common/TitleTooltip/TitleTooltip';
import { TransactionBudgetTableItem } from './getBudgetsTransactionsByPeriod';

export interface BudgetTransactionRowProps {
  transactionName: string;
  transaction: Record<string, TransactionBudgetTableItem>;
  groupedTransactionTypes: Record<string, string>;
  displayedPeriod: string[];
}

const maxDescriptionLength = 30;

export default function BudgetTransactionRow({
  transactionName,
  transaction,
  groupedTransactionTypes,
  displayedPeriod
}: BudgetTransactionRowProps) {
    const formatAmount = useCurrencyFormat();

    const shortenedDescription = truncate(transactionName, {
        length: maxDescriptionLength,
        omission: '...'
    });

    return (
        <TableRow key={transactionName}>
            <TableCell
                sx={{
                    width: '20rem',
                    position: 'sticky',
                    left: 0,
                    zIndex: 100,
                    backgroundColor: 'white',
                }}
            >
                <Box display="flex" alignItems="center">
                    <Box display="flex">
                        {groupedTransactionTypes[transactionName] === CostType.project && (
                            <DesignServicesOutlinedIcon sx={{ marginRight: '0.5rem' }} />
                        )}
                        {groupedTransactionTypes[transactionName] === CostType.contractor && (
                            <PaymentOutlinedIcon sx={{ marginRight: '0.5rem' }} />
                        )}
                        {groupedTransactionTypes[transactionName] === CostType.transaction && (
                            <AccountBalanceWalletOutlinedIcon
                                sx={{ marginRight: '0.5rem' }}
                            />
                        )}
                    </Box>
                    <TitleTooltip title={transactionName} placement="top">
                        <Typography variant="body2">{shortenedDescription}</Typography>
                    </TitleTooltip>
                </Box>
            </TableCell>
            {displayedPeriod.map((period) => (
                <TableCell key={period} align="center">
                    <Typography variant="body2">
                        {transaction[period] ? formatAmount(Number(transaction[period].targetAmount), transaction[period].currency) : '-'}
                    </Typography>
                </TableCell>
            ))}
            <TableCell colSpan={displayedPeriod.length} />
        </TableRow>
    )
};
